export function detectContentFormat(content) {
    if (!content || !content.trim()) return 'empty';

    const trimmed = content.trim();

    if (trimmed.startsWith('{')) {
        try {
            const parsed = JSON.parse(trimmed);
            if (Object.hasOwn(parsed, 'root')) return 'json';
        }
        catch (e) {
        }
    }

    if (isEmptyHtml(trimmed)) return 'empty';

    return 'html';
}

// Empty = no text and no media (e.g. Quill's "<p><br></p>"); HTML carrying media stays legacy.
function isEmptyHtml(html) {
    if (/<(img|video|iframe|embed|figure|source|audio)\b/i.test(html)) return false;
    const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, '')
        .trim();
    return text.length === 0;
}
